export const SvgSignatureHomes = (props) => {
	return (
		<svg
			width="16"
			height="10"
			viewBox="0 0 16 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.1204 1.14125C14.8892 1.07111 14.6258 1.182 14.5115 1.39714C13.9163 2.53395 12.9661 3.89712 11.865 3.84277C10.34 3.79065 8.90462 1.27486 8.4787 0.31023C8.46959 0.287642 8.45347 0.274057 8.44213 0.258102C8.41929 0.22193 8.39629 0.183387 8.36436 0.151639C8.34152 0.129052 8.31405 0.113098 8.28658 0.0973C8.25896 0.0815045 8.23835 0.0543357 8.20865 0.0407528H8.19715C8.16505 0.0271684 8.12848 0.0225877 8.09191 0.0181651C8.05981 0.0112152 8.03235 0 8.00025 0C7.96814 0 7.94068 0.0112148 7.91097 0.018007C7.87201 0.0225877 7.83543 0.0270107 7.80334 0.0405947H7.7896C7.76214 0.0541792 7.74377 0.0767669 7.7187 0.0903525C7.69123 0.110887 7.65913 0.124471 7.6339 0.151639C7.6018 0.183389 7.58119 0.219561 7.55836 0.258102C7.54686 0.273897 7.53089 0.287482 7.52179 0.310229C7.09362 1.27486 5.66051 3.79065 4.13791 3.84277C3.04363 3.90611 2.08656 2.53394 1.48898 1.39714C1.37447 1.17979 1.11352 1.06874 0.875406 1.14125C0.637295 1.21138 0.479353 1.4401 0.50219 1.68476L1.24638 9.53117C1.27161 9.79844 1.49599 10 1.76846 10L8.00024 9.99984H14.2345C14.5023 9.99984 14.7313 9.79829 14.7541 9.53102L15.4982 1.6846C15.5188 1.44009 15.3632 1.21137 15.1205 1.14121L15.1204 1.14125ZM13.7604 8.96946H2.2445L1.74082 3.64107C2.49859 4.49247 3.31592 4.91831 4.17446 4.87978C5.94886 4.81628 7.31112 2.887 8.0002 1.66644C8.68929 2.887 10.0515 4.81629 11.8258 4.87739C12.6958 4.91593 13.5017 4.49024 14.2594 3.63868L13.7604 8.96946Z"
				fill="url(#paint0_linear_5290_15464)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_5290_15464"
					x1="0.5"
					y1="0.666668"
					x2="15.7619"
					y2="1.65347"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#857D4C" />
					<stop offset="0.0808516" stopColor="#BD9A64" />
					<stop offset="0.510071" stopColor="#FBDE98" />
					<stop offset="0.897799" stopColor="#BD9A64" />
					<stop offset="1" stopColor="#857D4C" />
				</linearGradient>
			</defs>
		</svg>
	);
};
